import assetPath from '/opt/actions-runner/_work/crate/crate/packages/entity-pages/entity-pages-location/src/assets/mapIcon.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')